
<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      </div>

      <div>
        <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData" v-can="'A'">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
        </div>
      </div>
    </div>

    <div class="vx-row">

      <div class="vx-col w-full lg:w-1/3 mb-base" 
      v-for="anggaran in anggarans" 
      :key="anggaran.id">
        <vx-card class="overflow-hidden">
            <template slot="no-body">
                <div class="flex justify-between items-center p-6 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
                    <div>
                        <h4 class="font-semibold">{{ anggaran.task_title }}</h4>
                        <vs-progress :percent="100" :color="anggaran.color"></vs-progress>
                        <span class="font-semibold text-lg">{{ anggaran.lokasi }} - </span>
                        <span class="font-semibold text-lg">{{ anggaran.tahun }}</span>
                    </div>
                    <div>
                      <vs-button @click.stop="editData(anggaran)" v-can="'E'" radius :color="anggaran.color" icon-pack="feather" icon="icon-edit-2" size="small" class="mb-2"></vs-button>
                      <vs-button @click.stop="printData(anggaran.id, anggaran.task_title)" v-can="'E'" radius :color="anggaran.color" icon-pack="feather" icon="icon-printer" size="small" class=""></vs-button>
                    </div>
                </div>
                <ul class="tasks-today-container mt-4 mb-4">
                    <li class="px-6 py-2 tasks-today__task">
                      <vs-row>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="4">
                            <p class="text-lg">Cost</p>
                        </vs-col>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="6">
                            <p class="font-semibold text-lg pl-4">{{ anggaran.cost | currency }}</p>
                        </vs-col>
                        <vs-col vs-align="right" class="" vs-w="2">
                          <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-edit-2" size="small" class="ml-3" :to="{path:`/proyek/pekerjaan/${anggaran.task_name}/all`}"></vs-button>
                        </vs-col>
                      </vs-row>
                    </li>
                    <li class="px-6 py-2 tasks-today__task">
                      <vs-row>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="4">
                            <p class="text-lg">PPN 10 %</p>
                        </vs-col>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="6">
                            <p class="font-semibold text-lg pl-4">{{ anggaran.ppn | currency }}</p>
                        </vs-col>
                        <vs-col vs-align="right" class="tasks-today__actions" vs-w="2">
                        </vs-col>
                      </vs-row>
                    </li>
                </ul>
                <ul class="tasks-today-container mt-4 mb-4">
                    <li class="px-6 py-2 tasks-today__task">
                      <vs-row>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="4">
                            <p class="text-lg">Total</p>
                        </vs-col>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="6">
                            <p class="font-semibold text-lg pl-4">{{ anggaran.total | currency }}</p>
                        </vs-col>
                        <vs-col vs-align="right" class="tasks-today__actions" vs-w="2">
                        </vs-col>
                      </vs-row>
                    </li>
                    <li class="px-6 py-2 tasks-today__task">
                      <vs-row>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="4">
                            <p class="text-lg">Dibulatkan</p>
                        </vs-col>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="6">
                            <p class="font-semibold text-lg pl-4">{{ anggaran.pembulatan | currency }}</p>
                        </vs-col>
                        <vs-col vs-align="right" class="tasks-today__actions" vs-w="2">
                        </vs-col>
                      </vs-row>
                    </li>
                </ul>
                <!--
                <ul class="tasks-today-container mt-4 mb-4">
                    <li class="px-6 py-2 tasks-today__task">
                      <vs-row>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="4">
                            <p class="text-lg">Unit</p>
                        </vs-col>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="6">
                            <p class="font-semibold text-lg pl-4">{{ anggaran.unit }}</p>
                        </vs-col>
                        <vs-col vs-align="right" class="tasks-today__actions" vs-w="2">
                        </vs-col>
                      </vs-row>
                    </li>
                    <li class="px-6 py-2 tasks-today__task">
                      <vs-row>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="4">
                            <p class="text-lg"></p>
                        </vs-col>
                        <vs-col vs-align="center" class="pr-2 py-1" vs-w="6">
                            <p class="font-semibold text-lg pl-4">{{ anggaran.jumlahtotal | currency }}</p>
                        </vs-col>
                        <vs-col vs-align="right" class="tasks-today__actions" vs-w="2">
                        </vs-col>
                      </vs-row>
                    </li>
                </ul>
                -->
            </template>
        </vx-card>
      </div>
    </div>

    <vs-prompt
      color="danger"
      title="Konfirmasi"
      @accept="deleteData(hapusId, hapusAnggaran)"
      @close="close"
      :active.sync="hapus">
      <div class="con-exemple-prompt">
        Yakin ingin menghapus anggaran {{ hapusAnggaran }}
      </div>
    </vs-prompt>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="AnggaranNama"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
      >
      <section slot="pdf-content" class="cetak mx-12">
        <h4 class="mb-2 mt-2">RAB {{AnggaranNama}}</h4>
        <table style="width:100%">
          <tr>
            <th align="center">No</th>
            <th align="center">Uraian</th>
            <th align="center">Kode</th>
            <th align="center">Volume</th>
            <th align="center">Sat.</th>
            <th align="center">Harga Satuan</th>
            <th align="center">Jumlah Harga</th>
          </tr>
          <tr class="items-center">
            <th class="items-center">1</th>
            <th class="items-center" style="justify-content: center;">2</th>
            <th align="center">3</th>
            <th align="center">4</th>
            <th align="center">5</th>
            <th align="center">6</th>
            <th align="center">7</th>
          </tr>
          <tr :key="`${index}-data`" v-for="(data, index) in dataCetak">
            <td>{{ index+1 }} </td>
            <td>{{data.task_title}}</td>
            <td>{{data.kode}}</td>
            <td>{{data.task_quantity}}</td>
            <td>{{data.satuan}}</td>
            <td>{{data.harga | currency }}</td>
            <td>{{data.total | currency }}</td>
          </tr>
        </table>
      </section>
    </vue-html2pdf>

    <div class="pro-vs-loading px-12" v-if="onPro">
      <vs-progress :percent="onPercent" color="primary" class="mx-8">primary</vs-progress>
    </div>
  </div>
</template>

<script>
import DataViewSidebar from './AnggaranSidebar.vue'
import anggaranModule from '@/stores/proyek/anggaran.js'
import { mapGetters } from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    DataViewSidebar,
    VueHtml2pdf
  },
  data () {
    return {
      selected: [],
      // anggarans: [],
      itemsPerPage: 5,
      isMounted: false,
      Satuans: [],
      satuan: null,

      AnggaranNama: null,
      dataCetak: [],
      onPro: false,
      pageTable: 1,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      hapus: false,
      hapusId: null,
      hapusAnggaran: null,
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    anggarans () {
      return this.$store.state.anggaran.anggarans
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.anggarans.length
    },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteConfirm(id, anggaran){
      this.hapusId = id
      this.hapusAnggaran = anggaran
      this.hapus = true
    },
    deleteData (id) {
      const obj = {
        id: id,
        taxonomy: 'anggaran'
      }
      this.$store.dispatch('anggaran/removeAnggaran', obj)
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    close() {
      this.$emit('closed', false)
    },
    logout() {
      this.setAuth({}) 
      this.$router.push('/login').catch(() => {})
    },
    onProgress (event) {
      this.onPro = true
      this.onPercent = event
      if (event === 100) {
        this.onPro = false
        this.onPercent = 2
      }
    },
    printData(id, name) {
      let config = {
        headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.dataCetak = []
      this.AnggaranNama = name
      this.axios.get(`/task-cetak-pekerjaan/${id}`, config)
      .then((response) => {
        let {data} = response.data
        data.sort(function(a, b){
          return a.urutan - b.urutan;
        });
        this.dataCetak = data
        this.$refs.html2Pdf.generatePdf()
      })
      .catch((error) => {
        this.dataCetak = []
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text  : data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }
  },
  created () {
    this.$vs.loading()
    if (!anggaranModule.isRegistered) {
      this.$store.registerModule('anggaran', anggaranModule)
      anggaranModule.isRegistered = true
    }
    const obj = {
      action: 'create',
      page: this.pageTable,
      search: null,
    }
    this.$store.dispatch('anggaran/fetchAnggaran', obj)
    setTimeout(() => {
      this.$vs.loading.close()
    }, 4000)
    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list/satuan', configs)
    .then((response) => {
      let {data} = response.data
      this.Satuans = data
    })
    .catch((error) => {
      let data = error.data
      this.Satuans = data
    })

  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
.cetak {
  table, th {
    border: 1px solid black;
    border-collapse: collapse;
  }
  td {
    padding-left: 4px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-collapse: collapse;
  }
}
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .tasks-today-container {
    .tasks-today__task {
        transition: background .15s ease-out;
        .tasks-today__actions {
            display: none;
        }

        &:hover {
            background: rgba(var(--vs-primary),.04) ;
            .tasks-today__actions {
                display: flex;
            }
        }
    }
  }
}
.pro-vs-loading {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: hsla(0,0%,100%,.6);
  z-index: 300000;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
}
</style>
